import {Editor} from '@tinymce/tinymce-react';
import React from "react";

export const TextEditor = React.forwardRef((props, ref) => {
  const { addToInit = {}, addToToolbar = []} = props;
  return (
    <Editor
      ref={ref}
      init={{
        plugins: ['table emoticons image lists textcolor'],
        toolbar: [
          'bold italic underline | strikethrough subscript superscript | fontselect fontsizeselect',
          'alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | forecolor backcolor image emoticons | table',
          ...addToToolbar
        ],
        menubar: false,
        branding: false,
        ...addToInit
      }}
      {...props}
    />
  );
});